module.exports = __webpack_public_path__ + "b1938a9a45c7cb6c0c446cb9198eb925.png";